
import PageHeader from '../../../../Components/UI/PageHeader'
import EmployeRequestsDataTable from '../../../../Components/hr/employrequests/employrequestsIndex/employerequestsDataTable'



const EmployRequests = () => {
  return (
    <div> 
      <PageHeader title="Employe Requests" showButton={true} url={`${process.env.PUBLIC_URL}/employerequestsstore`}/>
      <EmployeRequestsDataTable/></div>
  )
}

export default EmployRequests